import { SearchLg } from '@untitledui/icons';
import { useCallback } from 'react';

import { Button } from '@/lib/base/buttons/button';
import { isMacPlatform } from '@/lib/utils/platform';

import { openGlobalSearch } from './useGlobalSearch';

/**
 * A visible way into the global search — an input-shaped button that opens
 * the Cmd/Ctrl+K palette.
 *
 * The read-only dashboard renders it in the hero slot where a full seat has
 * the chat composer: a viewer can't ask the agent anything, but finding a
 * contact, company, or deal is the thing they came to do.
 */
export const SEARCH_LAUNCHER_LABEL = 'Search contacts, companies, and deals';

export function SearchLauncher() {
  const handleClick = useCallback(() => {
    openGlobalSearch();
  }, []);

  return (
    <Button
      color='secondary'
      size='lg'
      iconLeading={SearchLg}
      onClick={handleClick}
      aria-label={SEARCH_LAUNCHER_LABEL}
      aria-haspopup='dialog'
      // Input-shaped: full width, left-aligned, placeholder-weight text —
      // it reads as "type here" while staying a real button.
      className='w-full !justify-start !rounded-xl !px-4 !py-3 !font-normal !text-[var(--color-text-placeholder)] [&_[data-text]]:flex-1'
    >
      <span className='flex w-full items-center gap-3'>
        <span className='flex-1 text-left text-sm'>
          {SEARCH_LAUNCHER_LABEL}
        </span>
        <kbd
          aria-hidden='true'
          className='hidden shrink-0 rounded border border-secondary bg-bg-secondary px-1.5 py-0.5 text-xs font-normal text-tertiary sm:inline-flex'
        >
          {isMacPlatform() ? '⌘K' : 'Ctrl+K'}
        </kbd>
      </span>
    </Button>
  );
}
